<template>
  <div class="twofa-sent">
    <div class="logo">
      <img
        src="@/assets/images/bloom_logo.svg"
        alt="logo"
        class="img-fluid"
      />
    </div>
    <div class="message-container">
      <p>
        ご登録のメールアドレスへ本人認証用リンクを送信しました。<br />
        メール内から本人認証を完了してください。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoFASent',
};
</script>

<style scoped>
.twofa-sent {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  text-align: center;
}

.logo {
  margin-bottom: 50px;
}

.img-fluid {
  width: 300px;
  height: auto;
}

.message-container {
  background-color: #d4edda;
  color: #155724;
  padding: 20px;
  width: 471px;
  max-width: 90%;
  min-height: 100px;
  font-size: 14px;
  text-align: center;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
}

.message-container p {
  margin: 0;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .message-container {
    width: 100%;
    max-width: 400px;
    padding: 15px;
  }
  
  .img-fluid {
    width: 250px;
  }
}
</style> 